/**
 * Iniciar un acta: fundo, concesionaria (actas de cocina) y grupo de trabajo.
 * Reescrito en JSX legible el 2026-10-07 a partir del recuperado (2026-10-05):
 * mismo comportamiento, más la concesionaria, que sale del maestro y queda
 * guardada en la inspección (no se escribe a mano).
 */
import {
  rec_AccionAsync as AccionAsync,
  rec_I1 as claseTarjeta,
  rec_R1 as claseTitulo,
  rec_React as React,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_gr as IconoVolver,
  rec_q1 as opcionFundo,
} from "../../runtime/index.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

export function IniciarInspeccion({ plantilla, fundos, onVolver, onComenzar }) {
  const pideConcesionaria = Boolean(plantilla.contenido?.concesionaria);
  const [fundoId, setFundoId] = useState(fundos.length === 1 ? fundos[0].id : null);
  const [concesionarias, setConcesionarias] = useState(null);
  const [concesionariaId, setConcesionariaId] = useState(null);
  const unidades = plantilla.unidades;

  useEffect(() => {
    if (!pideConcesionaria) return;
    api(`/concesionarias`).then((lista) => {
      setConcesionarias(lista);
      if (lista.length === 1) setConcesionariaId(lista[0].id);
    }).catch(() => setConcesionarias([]));
  }, [pideConcesionaria]);

  const faltaFundo = fundos.length > 0 && !fundoId;
  const faltaConcesionaria = pideConcesionaria && !concesionariaId;
  const bloqueado = faltaFundo || faltaConcesionaria;
  const comenzar = (unidadId) => onComenzar(plantilla.id, unidadId, fundoId, pideConcesionaria ? concesionariaId : null);

  return (
    <section className={`${claseTarjeta} animar-entrada flex flex-col gap-3`}>
      <AccionAsync variante="texto" className="min-h-11 self-start" icono={IconoVolver} onClick={onVolver}>Elegir otra acta</AccionAsync>
      <h2 className={claseTitulo}>{plantilla.nombre}</h2>
      <p className="text-sm text-(--text)">Selecciona dónde vas a inspeccionar.</p>

      {fundos.length > 1 && (
        <label className="flex flex-col gap-1 text-sm text-(--text)">
          Fundo
          <SelectorMultiple value={fundoId} onChange={setFundoId} placeholder="Elige el fundo" opciones={fundos.map(opcionFundo)} />
        </label>
      )}
      {!fundos.length && <p className="text-xs text-(--text)">Todavía no hay fundos cargados. Avisa a quien administra el sistema.</p>}

      {pideConcesionaria && (
        concesionarias && !concesionarias.length ? (
          <p className="text-xs text-(--text)">Todavía no hay concesionarias cargadas. Avisa a quien administra el sistema.</p>
        ) : (
          <label className="flex flex-col gap-1 text-sm text-(--text)">
            Empresa concesionaria
            <SelectorMultiple value={concesionariaId} onChange={setConcesionariaId}
              placeholder={concesionarias ? `Elige la concesionaria` : `Cargando…`}
              opciones={(concesionarias ?? []).map((c) => ({ valor: c.id, value: c.id, etiqueta: c.nombre, label: c.nombre }))} />
          </label>
        )
      )}

      {unidades.length > 1 ? (
        <>
          <p className="text-sm text-(--text)">Grupo de trabajo</p>
          {unidades.map((u) => (
            <AccionAsync key={u.id} variante="secundario" className="min-h-12 w-full justify-start" disabled={bloqueado} onClick={() => comenzar(u.id)}>
              {u.nombre}{u.sedeNombre ? ` · ${u.sedeNombre}` : ``}
            </AccionAsync>
          ))}
        </>
      ) : unidades.length === 1 ? (
        <AccionAsync className="min-h-12 w-full" disabled={bloqueado} onClick={() => comenzar(unidades[0].id)}>Comenzar el acta</AccionAsync>
      ) : (
        <p className="text-sm text-(--text)">No hay un grupo disponible. Solicita a administración que revise la asignación.</p>
      )}
    </section>
  );
}
